// extracted by mini-css-extract-plugin
module.exports = {"downTriangle":"styles__downTriangle___26Fqk","defaultInfoBoxColor":"styles__defaultInfoBoxColor___1RhK4"};